<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="ChevronLeftIcon" @click="close()" />
    </template>
    <template #title>Privacy controls</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || isBasicUser"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-[25px]">
      <UpgradeToProCallout v-if="isBasicUser" class="mb-5">
        Privacy options are only available to with a Pro Membership
      </UpgradeToProCallout>

      <div :class="classes">
        <div class="flex items-start">
          <LockIcon class="mr-4 size-5 shrink-0 text-gray-800" />
          <div class="flex-1 text-gray-800">
            <div class="text-[16px] leading-[18px]">
              Make registration private
            </div>
            <div class="mt-1 text-[13px] leading-[17px] text-gray-500">
              Only you and people you invite can see the file and description.
            </div>
          </div>
          <Toggle
            v-model="isPrivate"
            size="lg"
            :disabled="loading"
            class="ml-4 shrink-0"
          />
        </div>
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, Toggle, useSheet } from '@dacr/library'
import { ChevronLeftIcon, CheckmarkIcon, LockIcon } from '@dacr/icons'
import UpgradeToProCallout from '@/features/billing/components/UpgradeToProCallout.vue'
import type { File } from '@/shared/graphql/router/graphql'
import { useFilePrivacySettings } from './useFilePrivacySettings'

const { close, triggerEvent } = useSheet()

const props = defineProps<{
  file: File
}>()

const { isPrivate, isBasicUser, loading, save } = useFilePrivacySettings(
  props.file
)

const classes = computed(() => ({
  'opacity-30 pointer-events-none': isBasicUser.value,
}))

const handleSave = async () => {
  const updated = await save()
  triggerEvent('success', updated)
  close()
}
</script>
